<template>
  <div class="mdl-layout__contain">
    <rewards-and-recognition
      :clientId="$store.getters.user.client_id"
      :userId="$store.getters.user.id"
    />
  </div>
</template>

<script>
import RewardsAndRecognition from 'ewage-portal-rewards-and-recognition'
  export default {
    name: 'r-r-view',
    components: { RewardsAndRecognition }
  }
</script>

<style lang="scss" scoped>

</style>